// External Imports
import React from 'react';

// Internal Imports
import { LANGUAGES } from '../../config/types/prop.mjs';
import { logos } from '../../config/logos.mjs';

// Component Definition
function Logo({ currentEdition, ...props }) {
  // eslint-disable-next-line react/jsx-props-no-spreading -- props spreading to support native img attributes
  return <img alt="Babbel Logo" src={logos[currentEdition]} height="30" width="195" {...props} />;
}

Logo.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

// Module Exports
export { Logo };
